
import { defineComponent } from 'vue'
import { nanoid } from 'nanoid'
import { staticIcons } from './helper'
import delIcon from '@remote/assets/images/del_folder.png'
import saveIcon from '@remote/assets/images/save_folder.png'
import { getAllFolderApi } from '@remote/store/hezi-file'
import { getDisks, getNetDrives } from '@remote/store/hezi-file/disk'
import { usePathSelector } from '@remote/store/hezi-file/path-selector'
import { IDiskPartitionItem, INetDrives } from '@remote/type/hezi'
import { fileExit, makeDir } from '@remote/api/adapter/shell-mqtt'
import { safeJSONParse } from '@shared/utils'
import buildInDiskIcon from '@remote/assets/images/disk/hd-disk.png'
import uDiskIcon from '@remote/assets/images/disk/u-disk.png'
import { toast } from '@remote/utils/dialog'
const sambaIcon = 'https://oss.shumeipan.cn/hezi/images/static/web/samba.png'
const webdavIcon = 'https://oss.shumeipan.cn/hezi/images/static/web/webdav.png'

export default defineComponent({
  setup () {
    return {
      pathSelector: usePathSelector(),
    }
  },
  data () {
    return {
      isLoadingFolders: false,
      uuid: '',
      isEdit: false,
      actionType: '',
      nodeId: '',
      isVisible: false,
      levelPadding: 20,
      val: '',
      filePathArray: ['下载'],
      defaultProps: {
        children: 'children',
        label: 'title',
        id: 'id',
        parentId: 'parentId',
        isLeaf: 'leaf',
      },
      count: 1,
      rootNode: null,
      chosenNode: null,
      insertData: {},
      insertDataMap: [],
      icons: {
        delIcon,
        saveIcon,
      },
      chosenNodeData: null,
      emptyText: '数据加载中...',
      showSelectDiskPanel: false,
      root: '',
      disks: [] as IDiskPartitionItem[],
      diskName: '内置磁盘',
    }
  },
  computed: {
    treeNodePath () { return { path: '内置磁盘/我的下载', limit: 1000, usage: 200 } },
    rootDiskSelectList () { return [{ path: '内置磁盘/我的下载', limit: 1000, usage: 200, title: '内置磁盘' }] },
    defaultExpandedKeys () {
      return []
    },
    chosenNodeDataId () {
      return this.chosenNodeData ? this.chosenNodeData.id || '' : ''
    },
    disableCreateNode () {
      console.log('disableCreateNode', this.chosenNodeData, this.isEdit)
      return !this.chosenNodeData
    },
    treeData () {
      return [
        {
          id: '',
          title: '内置磁盘',
          icon: staticIcons.dir,
          is_write: true,
          children: [],
          path: '',
        },
      ]
    },
  },
  watch: {
    disableCreateNode () {
      console.log('this.isEdit', this.isEdit)
    },
    chosenNodeDataId () {
      // this.isEdit = false
    },
    isEdit (next, prev) {
      console.log(next, prev)
    },
  },
  methods: {
    toggleShowSelectDiskPanel (hide = false) {
      if (hide) {
        this.showSelectDiskPanel = false
      } else {
        this.showSelectDiskPanel = !this.showSelectDiskPanel
      }
      this.chosenNode = null
      this.chosenNodeData = null
    },
    handelSelectDisk (path: string, diskName: string) {
      this.diskName = diskName
      this.root = path
      this.showSelectDiskPanel = false

      const theChildren = this.rootNode.childNodes
      theChildren.splice(0, theChildren.length)
      this.loadNode(this.rootNode, this.rootResolve)
    },
    stat (action, data) {
      this.$stat('remote_control_pc', action, data)
    },
    async getInitTree (resovle, data, isInit) {
      const list = await this.loadFunction(data ? data : this.treeData[0])
      console.log('list', list)
      if (isInit && !list.length) this.emptyText = '暂无数据'
      resovle(list)
    },
    async handleInput (_, data) {
      let path = ''
      console.log('handleInput', this.chosenNodeData, this.treeNodePath)
      if (this.chosenNode && this.chosenNodeData?.path) {
        path = `${this.chosenNodeData.path}/${data.title.trim()}`
      } else {
        path = `${this.root}/${data.title.trim()}`
      }
      const isExit = await this.checkFolderIsExit(path)
      if (!isExit) {
        if (!data.title) {
          this.onMessageTip('error', '文件夹名称不能为空，请输入文件夹名称', 2000)
          return
        }

        makeDir(path)
          .then(() => {
            if (data.isEdit) {
              data.id = path
              data.isEdit = false
              data.path = path
            }
            this.isEdit = false
            this.insertData = {}
            this.uuid = ''
            this.onMessageTip('success', '文件夹创建成功', 2000)
          })
          .catch((err) => {
            console.log('err->', err)
            this.isEdit = false
            this.onMessageTip('error', `${err}`, 2000)
          })
      } else {
        this.isEdit = true
        this.onMessageTip('error', '创建失败，文件夹名称不能重复', 1000)
      }
    },
    async checkFolderIsExit (path:string) {
      let errMsg = ''
      try {
        const [err, res] = await fileExit(path)
        console.log('err', err, res)
        if (!err && res?.data) {
          const data = safeJSONParse(res?.data) as {result: {exist:boolean}}
          if (data?.result?.exist) errMsg = '文件夹已存在'
        } else {
          errMsg = err?.error_description ||  res.msg || ''
        }
      } catch (error) {
        console.log('err', error)
      }
      return errMsg
    },
    handleNodeClick (data, node) {
      this.chosenNodeData = data
      this.chosenNode = node
      console.log('handleNodeClick', JSON.stringify(node.data))
      if (!node.data.isTemp) this.$nextTick(() => {
        this.$refs['tree']?.remove(this.insertData)
        this.insertData = {}
        this.uuid = ''
        this.isEdit = false
      })
    },
    handelCollapse (data, node) {
      this.$refs.tree.setCurrentKey(data.id)
      this.chosenNodeData = data
      this.chosenNode = node
    },
    handelExpand (data, node) {
      this.$refs.tree.setCurrentKey(data.id)
      this.chosenNodeData = data
      this.chosenNode = node
    },
    async loadNode (node, resolve) {
      console.log('loadNode', node)
      if (node.level === 0) {
        this.rootNode = null
        const {root, disks} = await getDisks()
        const netDrives = await getNetDrives()
        this.root = root
        this.disks = disks

        resolve(
          [
            ...disks.map((disk:IDiskPartitionItem, index) => ({
              id: disk.uuid,
              title: disk.display_name,
              icon: disk.removable ? uDiskIcon : buildInDiskIcon,
              path: disk.mount,
              is_write: true,
              parent_id: disk.uuid,
              __order: index,
              params: {},
              isDir: true,
            })),
            ...netDrives.map((disk:INetDrives, index) => ({
              id: disk.id,
              title: disk.url,
              icon: disk.type === 'WebDAV' ? webdavIcon : sambaIcon,
              path: disk.mount,
              is_write: true,
              parent_id: disk.id,
              __order: index,
              params: {},
              isDir: true,
            })),
          ],
        )
      }

      if (node.level === 1) {
        this.root = node.data.path
        this.diskName = node.data.title
        this.rootNode = node
        this.rootResolve = resolve
        this.getChildByList(this.treeData[0], resolve, true)
      }

      if (node.level >= 1) {
        this.getChildByList(node.data, resolve)
      }
    },
    getChildByList (data, resolve, isInit = false) {
      if (data.isEdit) return resolve([])
      this.getInitTree(resolve, data, isInit)
    },
    handelDelItem () {
      // 选中当前输出框的操作
      if (this.uuid === this?.chosenNodeData?.id) {
        this.chosenNode = ''
        this.chosenNodeData = ''
      }
      this.$nextTick(() => {
        this.$refs['tree'] && this.$refs['tree'].remove(this.insertData)
        this.insertData = {}
        this.uuid = ''
        this.isEdit = false
      })
    },
    async loadFunction (node, limit = 50, next_page_token = '') {
      const param = {
        page_size: limit,
        file_path: encodeURIComponent(node.path || this.root),
        last_page_token: next_page_token || '',
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const [err, data] = await getAllFolderApi(param)
      if (!err && data && Array.isArray(data)) {
        return data
      } else {
        return []
      }
    },
    handleCreateNode (evt) {
      if (!this.chosenNode && !this.rootNode) {
        this.onMessageTip('info', '请选择文件夹', 2000)
        return
      }

      const chosenNode = this.chosenNode || this.rootNode
      const chosenNodeData = this.chosenNodeData || this.rootNode

      let target = evt.target
      console.log('handleCreateNode->', evt)
      if (target.nodeName == 'SPAN') {
        target = evt.target.parentNode
      }

      target.blur()
      if (Object.keys(this.insertData).length > 0) {
        this.$refs['tree'] && this.$refs['tree']?.remove(this.insertData)
        this.insertData = {}
      }

      if (chosenNode) {
        this.actionType = 'create'
        //新增数据
        if (!chosenNodeData.children) {
          chosenNodeData.children = []
        }
        if (!this.uuid) {
          this.uuid = nanoid()
        }
        this.insertData = {
          id: this.uuid,
          icon: staticIcons.dir,
          title: '新建文件夹',
          parentId: chosenNodeData.id,
          path: chosenNodeData.path,
          children: [],
          // leaf: true,
          isTemp: true,
          isEdit: true,
          is_write: true,
        }
        if (this.chosenNode) {
          chosenNodeData.children.push(this.insertData)
        } else {
          this.$refs['tree'].append(this.insertData, this.rootNode)
        }
        //同时展开节点
        if (!chosenNode.expanded) {
          chosenNode.expanded = true
        }
        this.isEdit = true
        console.log('slotTreeInput', this.uuid)
        this.$nextTick(() => {
          const currentSlotTreeInput = this.$refs[`slotTreeInput${this.uuid}`]
          if (currentSlotTreeInput.$refs.input) {
            currentSlotTreeInput.$refs.input.focus()
            currentSlotTreeInput.$refs.input.select()
          }
        })
      } else {
        this.onMessageTip('info', '请选择文件夹', 2000)
      }
    },
    confirm () {
      if (!this.chosenNodeData && !this.root) {
        this.onMessageTip('info', '请选择文件夹', 2000)
        return
      }

      if (this.chosenNodeData) {
        const curretDisk = this.disks.find(item => item.mount === this.root)
        this.pathSelector.setSelectedPath({
          id: this.chosenNodeData?.id || this.root,
          path: this.chosenNodeData?.path || this.root,
          size: curretDisk?.size,
          free:curretDisk?.free,
          diskName: this.diskName,
        })
      }
      this.pathSelector.toggleVisibleSelectFolder(false)
    },
    cancel () {
      this.$nextTick(() => {
        this.$refs['tree']?.remove(this.insertData)
        this.insertData = {}
        this.uuid = ''
        this.isEdit = false
      })
      this.chosenNode = null
      this.chosenNodeData = null
      this.pathSelector.toggleVisibleSelectFolder(false)
    },
    onMessageTip (type, p, time = 5000) {
      toast(p)
    },
  },
})
